module.exports = __webpack_public_path__ + "img/dcmm_27.56c9a0c2.png";